import React, { useCallback } from 'react'
import { Image, Stack } from '@mantine/core'
import { useLotteryData } from './hooks'
import LotteryRules from './LotteryRules'
import ScratchCard from './ScratchCard'
import ErrorDisplay from './components/ErrorDisplay'
import SideContactService from './components/SideContactService'
import SideShareActivity from './components/SideShareActivity'
import { Dialog } from 'antd-mobile'
import { useNavigate } from 'react-router-dom'
import { USER_TOKEN_KEY } from '../constants/localStorageConstants'

const Lottery: React.FC = () => {
  const { loading, error, customerServiceUrl, currentMerchant, refreshData } = useLotteryData()
  const navigate = useNavigate()

  const handleShareReward = useCallback(() => {
    refreshData().then()
  }, [refreshData])

  const handleLogout = useCallback(() => {
    Dialog.confirm({
      content: '确定要退出登录吗？',
      confirmText: '退出',
      cancelText: '取消',
      onConfirm: () => {
        localStorage.removeItem(USER_TOKEN_KEY)
        navigate('/merchantLogin')
      },
    })
  }, [navigate])

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: 'linear-gradient(135deg, #FE4145 0%, #FF6B6B 100%)',
        }}
      >
        <div
          style={{
            color: 'white',
            fontSize: 18,
            fontWeight: 600,
            animation: 'pulse 1.5s ease-in-out infinite',
          }}
        >
          🎯 加载中...
        </div>
      </div>
    )
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflowX: 'hidden',
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #FE4145 0%, #FF6B6B 50%, #E74C3C 100%)',
        position: 'relative',
      }}
    >
      {/* 代理商姓名 - 右上角低调显示 */}
      {currentMerchant?.name && (
        <div
          onClick={handleLogout}
          style={{
            position: 'fixed',
            top: '16px',
            right: '16px',
            zIndex: 10,
            background: 'rgba(0, 0, 0, 0.1)',
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '11px',
            padding: '4px 8px',
            borderRadius: '8px',
            fontWeight: 500,
            backdropFilter: 'blur(4px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(0, 0, 0, 0.2)'
            e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(0, 0, 0, 0.1)'
            e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'
          }}
        >
          {currentMerchant.name}
        </div>
      )}

      <LotteryRules />
      <SideContactService />
      <SideShareActivity onShareReward={handleShareReward} />

      <div
        style={{
          width: '100%',
          maxWidth: 480,
          margin: '0 auto',
          boxSizing: 'border-box',
          position: 'relative',
          background: 'transparent',
        }}
      >
        <div
          style={{
            position: 'relative',
            borderRadius: '20px 20px 0 0',
            overflow: 'hidden',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
          }}
        >
          <Image
            src="./lotteryBanner.png"
            alt="活动海报"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
            }}
          />
        </div>

        <div
          style={{
            background: 'linear-gradient(180deg, #FE4145 0%, #FF5A5A 100%)',
            borderRadius: '0 0 20px 20px',
            position: 'relative',
          }}
        >
          <Stack px={8} pb={32} gap={20}>
            {error ? <ErrorDisplay error={error} customerServiceUrl={customerServiceUrl} /> : <ScratchCard />}
          </Stack>
        </div>
      </div>
    </div>
  )
}

export default Lottery
